const headerInlineStyle1 = {
  fontSize: "18px",
};

export const ONR_SwitchTieRequirementsSchemaSection = {
  heights: {
    header1: "auto",
    header2: "auto",
  },
  inlineStyle: {
    header1: headerInlineStyle1,
    header2: headerInlineStyle1,
  },
  minDataRowsCount: 10,
  columns: [
    {
      title: "Switch Name",
      colSpan: 3,
      rowSpan: 2,
      className: "tbl-text-normal",
      accessor: "assetName",
    },
    {
      title: "Mileage",
      colSpan: 2,
      rowSpan: 2,
      className: "tbl-text-normal",
      accessor: "milepostWithMp",
    },
    {
      title: "# of Ties Required",
      colSpan: 9,
      rowSpan: 1,
      className: "tbl-text-normal",
      columns: [
        {
          title: "8'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch8",
        },
        {
          title: "9'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch9",
        },
        {
          title: "10'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch10",
        },
        {
          title: "11'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch11",
        },
        {
          title: "12'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch12",
        },
        {
          title: "13'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch13",
        },
        {
          title: "14'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch14",
        },
        {
          title: "15'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch15",
        },
        {
          title: "16'",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.inch16",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/SwitchTieRequirements/ONR_SwitchTieRequirementsSchema.js